import React, { Component, ReactNode } from 'react'
import { Form, Dropdown as SDropdown, Input as SInput, Button as SButton, FormDropdownProps, DropdownItemProps, Grid, StrictGridColumnProps, FormInputProps, Modal, Label, Dimmer, Table, Loader, Container, Checkbox, Message } from 'semantic-ui-react'
import { FastField, Field, getIn } from 'formik'
import ErrorMessage from './ErrorMessage'
import { FormikComponentProps, getFieldError, setFieldValue } from './FormikHelpers'
import { collectFeatureOptions, getLocalizedLabel, getmeta, getRefTargets, Meta, Query, RatatoskRequest, RatatoskResponse, valueInOptions, valueIsSimpleId, valueNotEmpty } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'
import { AxiosInstance } from 'axios'
import { decodeName, encodeName, extractName } from './InputFeatureValueRef'

export interface SelectCunitProps extends FormikComponentProps, WithTranslation {
  meta: Meta,
  http: AxiosInstance,
  multi: boolean,
  values: string[],
  update: (value) => void,
  close: () => void,
  cunitType: string
}

interface SelectCunitState {
    keywords: string,
    response: RatatoskResponse|null,
    errorMsg: string,
    searching: boolean,
    method: string
}

class SelectCunit extends Component<SelectCunitProps, SelectCunitState> {

    state = {
        keywords: '',
        response: null as RatatoskResponse|null,
        errorMsg: '',
        searching: false,
        method: 'fulltext'
    }
    timer: any = null
    page_size = 100
  
    methods = [
        {key: 'fulltext', value: 'fulltext', text: this.props.t('Keywords')},
        {key: 'name_prefix', value: 'name_prefix', text: this.props.t('Name (prefix)')}
    ]

    componentDidUpdate (prevProps, prevState) {
        if((prevState.keywords !== this.state.keywords || prevState.method !== this.state.method) && this.state.keywords.length>1) {
            // Clears running timer and starts a new one each time the user types
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.search()
            }, 1000)
        }
    }

    search() {
        const { meta, http, cunitType } = this.props
        const { keywords, method } = this.state
        const url = 'cunits/_view'
        let query = {type: cunitType}
        if (method==='fulltext') {
            query['_custom'] = {forms: keywords}
        } else if (method==='name_prefix') {
            query['name'] = keywords + '*'
        }
        let request: RatatoskRequest = {query: query, page: {from: 0, size: this.page_size}, sort: [{'name.cs_sort':{'order':'asc'}}]}
        this.setState({searching: true})
        http.post(url, request)
            .then(response => {
                this.setState({response: response.data, errorMsg: '', searching: false})
            }).catch(err => {
                if (err.response) {
                    // UNAUTHORIZED
                    if (err.response.status===401) {
                        let newState = {errorMsg: err.response.data.message, searching: false}
                        //if (err.response._user_id!==meta.user['id']) newState['sessionExpired'] = true
                        this.setState(newState)
                    } else {
                        this.setState({searching: false, errorMsg: err.response.data.message, response: null})
                    }
                }
            })
    }

    render() {
        const {meta, multi, values, update, t} = this.props
        const { keywords, response, errorMsg, searching } = this.state

        const names = values.map(v => extractName(v))

        const toggle = (name) => {
            const newRef = `@[name=${encodeName(name)}]`
            if (multi) {
                if (names.includes(name)) {
                    update(values.filter(v => v!==newRef))
                } else {
                    update([...values, newRef])
                }
            } else {
                update(newRef)
                close()
            }
        }

        return(
            <>
            <Grid>
                <Grid.Row verticalAlign="middle">
                    <Grid.Column width={13}>
                    <SInput name="select_cunit_keywords" fluid icon="search" loading={searching} value={keywords} onChange={(e, {name, value}) => this.setState({keywords: value})}/>
                    </Grid.Column>
                    <Grid.Column width={3}>
                    <SDropdown name="select_cunit_method" fluid selection options={this.methods} value={this.state.method} onChange={(e, {name, value}) => this.setState({method: value as string})}/>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Dimmer.Dimmable loading={searching} dimmed={searching} as={Container}>
            <Dimmer active={searching} inverted>
                <Loader inverted>{t('Loading...')}</Loader>
            </Dimmer>
            {errorMsg && <Message error icon='exclamation triangle' header={t('Error')} content={errorMsg}/>}
            { response && response.data.length ?
            <>
            {response?.total && response.total.value > this.page_size ? <Message info>{t('Showing first {{count}} of {{total}} entries', {count: this.page_size, total: response.total.value})}</Message> : null}
            <Table compact selectable className='select_cunit'>
                <Table.Body>
                {response.data.map((cunit, row) => {
                    return (
                        <Table.Row key={row} positive={names.includes(cunit._name)} onClick={() => toggle(cunit._name)}>
                            <Table.Cell>{cunit._name}</Table.Cell>
                        </Table.Row>
                    )
                })}
                </Table.Body>
            </Table>
            </>
            : null }
            </Dimmer.Dimmable>
            </>
        )
    }
}

export default withTranslation()(SelectCunit)